export default "__VITE_ASSET__f7c33ea1__"